module.exports = __webpack_public_path__ + "static/media/avatar_fish.1c824ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_fish.png
// module id = 378
// module chunks = 0